import StockInformation from '../../../../components/stock-information/stock-information.mobile';
import stockInformation from './stock-infomation';

export default stockInformation(StockInformation);
